import React from 'react'
import './style.css'

export default class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            searcher: 'character',
            disabledSubmit: 'true',
            error: false
        };


        this.characterPattern = new RegExp(/^[a-zA-Z][a-zA-Z_-]*$/);
        this.accountPattern = new RegExp(/[a-zA-Z0-9`~!@$^&()_\-=+{}|\[\];':]$/);

        this.handleChange = this.handleChange.bind(this);
        this.handleSearcherChange = this.handleSearcherChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSearcherChange(event) {
        const searcher = event.target.value;
        this.setState({ searcher: searcher });
        if (!this.validate(searcher, this.state.name)) {
            this.setState({ error: this.state.name.length > 0, disabledSubmit: 'true' });
        } else {
            this.setState({ error: false, disabledSubmit: '' });
        }
    }

    handleChange(event) {
        const name = event.target.value.toLowerCase();
        this.setState({ name: name });
        if (!this.validate(this.state.searcher, name)) {
            this.setState({ error: name.length > 0, disabledSubmit: 'true' });
        } else {
            this.setState({ error: false, disabledSubmit: '' });
        }
    }

    getPattern(searcher) {
        if (searcher === 'character') {
            return this.characterPattern;
        } else {
            return this.accountPattern;
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.error === false) {
            window.location.href = `${this.state.searcher}/${this.state.name}`;
        }
    }

    validate(searcher, name) {
        if ((name.length < 2 || name.length > 16) || !this.getPattern(searcher).test(name)) {
            return false;
        } else {
            return true;
        }
    }

    render() {
        return <div className="home">
            <h1>The armory</h1>
            <p>This is where you can search all the Diablo 09 characters and get a detailed view of their skills, items, stats and mercenary.</p>
            <div className="searcher">
                <form onSubmit={this.handleSubmit}>
                    <input type="text" onChange={this.handleChange} />
                    {this.state.error === true && <p className="error-label">Invalid {this.state.searcher} name, please try another.</p>}
                    <label><input type="radio" value="character" checked={this.state.searcher === "character"} onChange={this.handleSearcherChange}/>Character</label>
                    <label><input type="radio" value="account" checked={this.state.searcher === "account"} onChange={this.handleSearcherChange}/>Account</label>
                    <button disabled={this.state.disabledSubmit} className="mdl-button mdl-button--raised mdl-button--colored" type="submit">Search</button>
                </form>
            </div>

        </div>
    }
};



// WEBPACK FOOTER //
// ./src/components/home/index.js